<template>
    <page-view>
        <template slot="action">
            <a-button style="margin-left: 10px" @click="exportExcel">
                <a-icon type="file-add" theme="twoTone" two-tone-color="#52c41a"/>
                导出EXCEL
            </a-button>&nbsp;
<!--            <a-popconfirm title="是否确认支付?" @confirm="onPay">-->
<!--                <a-button type="primary" :loading="payLoading">支付</a-button>-->
<!--            </a-popconfirm>-->
        </template>
        <a-card>
            <a-row>
                <a-col :span="10">
                  <a-form-model-item label="指定日期" v-bind="formItemLayout">
                    <a-range-picker format="YYYY-MM-DD" v-model="appointTime" :allowClear="false"/>
                  </a-form-model-item>
                </a-col>
              <a-col :span="10" :offset="1">
                <a-form-model-item label="指定部门" v-bind="formItemLayout">
                  <dept-selector multiple v-model="deptIds" @change="onDeptChange" />
                </a-form-model-item>
              </a-col>
              <a-col :span="2" :offset="1">
                &nbsp;<a-button type="primary" @click="loadData">查询</a-button>
              </a-col>
            </a-row>
            <br/>
            <table class="fx-form-view" style="text-align: center">
                <!--<col width="120px"/>-->
                <!--<col/>-->
                <tr>
                    <th width="80px">姓名</th>
                    <th width="50px">序号</th>
                    <th width="120px">部门</th>
<!--                    <th width="190px">身份证</th>-->
                    <th>聘请时间</th>
                    <th width="50px">室外天数</th>
                  <th width="50px">室内天数</th>
                    <th width="100px">税后金额</th>
<!--                    <th width="70px">增值税</th>-->
<!--                    <th width="70px">城建税</th>-->
<!--                    <th width="70px">个税</th>-->
                    <th width="110px">税前金额</th>
                </tr>
                <tbody v-for="(item,i) in info" :key="i">
                <tr v-for="(item2,index2) in item.expertFeesList" :key="index2">
                    <td v-if="index2 === 0" :rowspan="item.expertFeesList.length + 1">{{item.name}}</td>
                    <td style="text-align: center">{{item2.no}}</td>
                    <td>{{item2.deptName}}</td>
<!--                    <td>{{item2.expertIdcard}}</td>-->
                    <td>
                      <a-tag v-for="(item3,index) in item2.expertTripDate"
                         :key="index">
                        <span v-for="(item4,index1) in item3.split(',')" :key="index1">{{item4}}<br/></span>
                      </a-tag>
                    </td>
<!--                    <td>{{item2.nNum}}</td>-->
<!--                    <td>{{item2.wNum}}</td>-->
<!--                    <td>{{item2.expertFees}}</td>-->
<!--                  <td>{{item2.se.zzs}}</td>-->
<!--                  <td>{{item2.se.cjs}}</td>-->
<!--                  <td>{{item2.se.gs}}</td>-->
<!--                    <td>{{item2.se.beforeTaxFees}}</td>-->
                  <td v-if="index2 === 0" :rowspan="item.expertFeesList.length + 1">{{item.wSum}}</td>
                  <td v-if="index2 === 0" :rowspan="item.expertFeesList.length + 1">{{item.nSum}}</td>
                  <td v-if="index2 === 0" :rowspan="item.expertFeesList.length + 1">{{item.feesSum}}</td>
                  <td v-if="index2 === 0" :rowspan="item.expertFeesList.length + 1">{{item.beforeTaxFees}}</td>
                </tr>
<!--                <tr style="font-weight: bold">-->
<!--                    <th colspan="2">小计</th>-->
<!--                    <th ></th>-->
<!--                    <th>{{item.nSum}}</th>-->
<!--                    <th>{{item.wSum}}</th>-->
<!--                    <th>{{item.feesSum}}</th>-->
<!--                    <th>{{item.beforeTaxFees}}</th>-->
<!--                </tr>-->
                </tbody>
                <tfoot>
                    <tr style="font-weight: bold">
                        <th :colspan="4">总计</th>
                        <th>{{feesExtras.wAll}}</th>
                        <th>{{feesExtras.nAll}}</th>
                        <th>{{feesExtras.feesAll}}</th>
                        <th>{{feesExtras.beforeTaxFeesAll}}</th>
                    </tr>
                </tfoot>
            </table>
        </a-card>
    </page-view>
</template>
<script>
import qs from 'qs'
import moment from 'moment'
import { PageView } from '@/layouts'
import DeptSelector from '@/components/selector/DeptSelector'
export default {
  name: 'expertDeptFeesMonth',
  components: {
    PageView,
    DeptSelector
  },
  data () {
    return {
      formItemLayout: {
        labelCol: {
          md: { span: 6 }
        },
        wrapperCol: {
          md: { span: 12 }
        }
      },
      payLoading: false,
      feesExtras: {},
      info: [],
      deptIds: '',
      appointTime: [moment(moment().format('YYYY-MM') + '-01'),moment(moment().add(1, 'M').format('YYYY-MM') + '-01')]
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    onDeptChange (e) {
      this.deptIds = e
    },
    async loadData () {
      const data = {
        appointStartTime: this.appointTime[0].format('YYYY-MM-DD'),
        appointEndTime: this.appointTime[1].format('YYYY-MM-DD'),
        deptIds: this.deptIds
      }
      const res = await this.$http.get('/api/1/expertmain/selectExpertFeedback/fees/stat_dept_month_fees.json', { params: data })
      if (res.code !== 200) {
        return
      }
      this.info = res.result.result
      this.feesExtras = res.result.feesExtras
      this.feesExtras.tripMaxLen = this.feesExtras.tripMaxLen === 0 ? 1 : this.feesExtras.tripMaxLen
    },
    // 修改支付状态的 请求方法
    onPay () {
      const that = this

      let data = {}
      data.projectIdList = this.feesExtras.projectIdList

      this.payLoading = true
      that.$http.post('/api/1/expertmain/selectExpertFeedback/update_feesState_byProjectIds.json', data).then(
        res => {
          if (res.code !== 200) {
            return
          }
          that.$message.success('操作成功！')
          that.$refs.table.refresh()
        }
      ).finally(function () {
        that.payLoading = false
      })
    },
    exportExcel () {
      if (this.info.length === 0) {
        this.$message.error('数据为空！')
        return
      }
      const data = {
        appointStartTime: this.appointTime[0].format('YYYY-MM-DD'),
        appointEndTime: this.appointTime[1].format('YYYY-MM-DD'),
        deptIds: this.deptIds
      }
      const url = '/api/1/expertmain/selectExpertFeedback/fees/export_month_expertDeptFees_excel.json'

      this.$http.post(url, qs.stringify(data), {
        responseType: 'blob'
      }).then(res => {
        let blob = new Blob([res], {
          type: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        let fileName = data.appointStartTime + '至' + data.appointEndTime + '专家费部门月统计.xls'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          let elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          document.body.removeChild(elink)
        }
      }).catch(err => {
        console.warn(err)
      })
    }
  }
}
</script>
<style lang="less" scoped>

    /*.fx-form-view {*/
    /*width: 100%;*/
    /*background-color: white;*/
    /*border-collapse: collapse;*/
    /*border: 1px solid #ccc;*/
    /*}*/

    /*.fx-form-view th {*/
    /*padding: 14px 8px 14px 10px;*/
    /*border: 1px solid #cde2fa;*/
    /*font-weight: normal;*/
    /*width: 120px;*/
    /*color: #444;*/
    /*background-color: #e9f8ff;*/
    /*height: 38px;*/
    /*}*/

    /*.fx-form-view td {*/
    /*padding: 14px 8px 14px 10px;*/
    /*border: 1px solid #cde2fa;*/
    /*//min-width: 100px;*/
    /*width: 180px;*/
    /*height: 38px;*/
    /*color: #444;*/
    /*}*/

</style>
